import React from 'react';
import { useParams } from 'react-router-dom';

import MetaTags from 'components/common/MetaTags';
import MeetRegistrationManager from 'components/meet/MeetRegistrationManager';

import styles from './MyMeetSignup.module.css';

// Case 2 — a portal user who is NOT a member of the host club (clubless, or a member of other clubs) manages their own
// athletes' registrations for a multi-club meet INSIDE their personal portal. Hosted by PersonalLayout, so they keep
// their identity + reset-password + logout chrome. The registration dashboard is the shared MeetRegistrationManager —
// the same component the in-club §6.10 page (Case 1) uses — which renders its own meet hero (title + "Meet Details"
// link, membership-aware) and the dashboard.

const MyMeetSignup = () => {
  const { meetId } = useParams();

  return (
    <div className={styles.page}>
      <MetaTags title="SplitFast | My Registrations" />
      <MeetRegistrationManager meetId={meetId} />
    </div>
  );
};

export default MyMeetSignup;
